/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { store } from "@/store";

//Top navs
import OverviewTopNav from "@/components/OverviewTopNav.vue";

import { BotStore, RootStore, UserStore } from "@/store/constants";
import { useAuthService } from "@/services/AuthService";

//Sub apps
import { AdminRoutes } from "./admin";
import { BotRoutes } from "./bot";
import { signInWithPermissions } from "@/api/user/auth";

let signInCalled = false;

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Overview",
    meta: {
      fullwidth: true,
      topnav: true
    },
    components: {
      default: () => import("../views/Overview.vue"),
      topnav: OverviewTopNav,
    },
  }, {
    name: "SignIn",
    path: "/sign-in",
    meta: {
      fullscreen: true,
      public: true
    },
    component: () => import(/* webpackChunkName: "sign-in" */ "../views/Auth/SignIn.vue"),
  },
  {
    path: "/password-recovery",
    meta: {
      fullscreen: true,
      public: true
    },
    component: () => import(/* webpackChunkName: "password-recovery" */ "../views/Auth/PasswordRecovery.vue"),
  },
  {
    path: "/password-reset",
    meta: {
      fullscreen: true,
      public: true
    },
    component: () => import(/* webpackChunkName: "password-reset" */ "../views/Auth/PasswordReset.vue"),
  },
  //Admin
  ...AdminRoutes,
  ...BotRoutes
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if(to.params.chatbotId) store.commit(BotStore.Mutations.SET_ID, to.params.chatbotId);
  await useAuthService();
  next();
});

router.beforeEach(async (to, from, next) => {
  if(to.meta.public) store.commit(RootStore.Mutations.SET_LOADER, false);
  if(!to.meta.public){
    const isSignedIn = store.getters[UserStore.Getters.IS_SIGNED_IN];
    if(!isSignedIn) return next({
      name: "SignIn"
    });
    if(!signInCalled){
      await signInWithPermissions();
      signInCalled = true;
      store.commit(RootStore.Mutations.SET_LOADER, false);
    }
  }
  next();
});

export default router;
